import { IUserDTO } from '@/dtos';
import { post } from '@/services/apiWrapper';

export const registerAPI = async (body: IUserDTO): Promise<IUserDTO> => {
  return await post<IUserDTO>('/register', body);
};

export const emailValidationAPI = async (
  email_address: string,
  token: string,
): Promise<boolean> => {
  const body = { email_address: email_address, token: token };
  const reg = await post<boolean>('/email-validation', body);
  return reg;
};
